// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoogleSquareFilledSvg from "@ant-design/icons-svg/es/asn/GoogleSquareFilled";
import AntdIcon from '../components/AntdIcon';

var GoogleSquareFilled = function GoogleSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoogleSquareFilledSvg
  }));
};

GoogleSquareFilled.displayName = 'GoogleSquareFilled';
export default /*#__PURE__*/React.forwardRef(GoogleSquareFilled);